<template>
  <div>
    <label class="emphasis">
      {{ $t('tenantProjects.greenFitOut.remarksToHkland') }}
    </label>
    <div v-if="isHKlandUser && !remarkList.length">
      {{ $t('emptyValue') }}
    </div>
    <div
      v-for="(remark, index) in remarkList"
      :key="index"
      class="remarks-list"
    >
      <div>
        <span class="remarks-list__content">{{ remark.remarks }}</span>
        <span class="remarks-list__text">{{ `${$t('tenantProjects.submission.sentByOn', [remark.createdBy.displayName, dateUtil.format(remark.createdAt, 'DD MMM YYYY HH:mm')])}` }}</span>
      </div>
    </div>
    <HKLForm
      v-if="isTenant"
      ref="formRef"
      class="remarks-group"
      @change="formUtils.setDirty()"
    >
      <HKLInput
        v-model="inputData"
        v-hkldinput
        v-fusioninputcheck="{
          type: 'string',
          required: true
        }"
        class="remarks-group__input"
      />
      <HKLButton
        color="orange"
        action="send"
        @click="send"
      />
    </HKLForm>
  </div>
</template>
<script>
import HKLForm from '@/controls/Form/HKLForm'
import HKLButton from '@/controls/Button/HKLButton'
import HKLInput from '@/controls/Input/HKLInput'
import { ref, unref, computed } from 'vue-demi'
import { fusionInputCheckUtil } from '@/plugin/FusionInputCheck'
import { utils as formUtils } from '@/plugin/InputChange'
import { useStoreGetters } from '@/store'
import { useCurrentGreenFitout, useRefreshCurrentGreenFitout } from './hook'
import dateUtil from '@/utils/dateUtil'
import { addRemarks } from '@/api/tenantProjects/greenFitout.request'
import { useRefForm } from '@/controls/Form/hook'

export default {
  components: {
    HKLForm,
    HKLButton,
    HKLInput,
  },
  setup () {
    const formRef = useRefForm()
    const currentGreenFitout = useCurrentGreenFitout()
    const remarkList = computed(() => unref(currentGreenFitout).tenantRemarks)
    const refresh = useRefreshCurrentGreenFitout()
    const { isTenant, isHKlandUser } = useStoreGetters('user', ['isTenant', 'isHKlandUser'])
    const inputData = ref('')
    const send = async () => {
      fusionInputCheckUtil.resetAllFields()
      if (!formRef.validate()) return
      await addRemarks(unref(currentGreenFitout).id, inputData.value)
      inputData.value = ''
      formUtils.resetDirty()
      await refresh()
    }
    return {
      isTenant,
      isHKlandUser,
      inputData,
      send,
      remarkList,
      formUtils,
      dateUtil,
      formRef: formRef.form,
    }
  },
}
</script>
<style lang="scss" scoped>
.remarks-list {
  margin-bottom: 5px;
  &__text{
    color: #878787;
    font-size: 12px;
    padding: 10px;
    font-style: italic;
  }
}
.remarks-group {
  display: flex;
  &__input {
    margin-right: 10px;
  }
}

</style>
